import { convertBreakpointsToMediaQueries } from '@/modules/utils/themeUtils';
import { styled } from '@volkswagen-onehub/components-core';

export const StyledOverlay = styled.div(
  ({ theme }) => `
  padding:0 ${theme.size.static300} 0 ${theme.size.static300};    
  ${convertBreakpointsToMediaQueries({
    b1280: {
      padding: `0 ${theme.size.static1200} 0 ${theme.size.static1200}`,
    },
  })}
`
);
